import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HotTopics from "./components/HotTopics";
import Categories from "./components/Categories";
import Reviews from "./components/Reviews";
import Debate from "./components/Debate";
import News from "./components/News";
import Guide from "./components/Guide";
import About from "./components/About";
import CtaBand from "./components/CtaBand";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="回到顶部"
      className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-none transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
    </button>
  );
}

export default function Home() {
  const [tag, setTag] = useState("全部");
  const [query, setQuery] = useState("");

  return (
    <>
      <Header />
      <main>
        <Hero onSearch={(q) => setQuery(q)} />
        <HotTopics />
        <Categories />
        <Reviews />
        <Debate />
        <News tag={tag} onTag={setTag} query={query} onClearQuery={() => setQuery("")} />
        <Guide />
        <About />
        <CtaBand />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}